import { useContext, useState } from 'react';
import { AppState } from '../context/general';
import { TextButton } from 't-lib-ui/widgets';
import { useOfflineMode } from '../utils/useOfflineMode';
import OfflineIcon from './OfflineIcon';
import './OfflineScreen.css';

// Full-page state shown instead of any app page while the engine is offline (see AppRouter).
// The sidebar keeps rendering next to it, so the user can still browse their feed list; every
// page they pick lands back here until the connection returns.
const OfflineScreen: React.FC = () => {
  const appState = useContext(AppState);
  const mode = useOfflineMode();
  const [retrying, setRetrying] = useState(false);

  // A manual retry does the same clean-slate load the engine retries on its own backoff.
  // On success the engine clears the offline mode and this whole screen is replaced.
  const retry = async () => {
    setRetrying(true);
    try { await appState.feedEngine.reloadData(); }
    finally { setRetrying(false); }
  };

  return (
    <div className="offlineScreen">
      <div className="offlineScreenBadge">
        <OfflineIcon className="offlineScreenIcon" size={72} />
      </div>
      <h1>{mode == 'event' ? 'You are offline' : 'Downread is unreachable'}</h1>
      <p>
        {mode == 'event'
          ? 'Your device has no internet connection, so new posts cannot be loaded right now.'
          : 'Your posts cannot be loaded because the Downread server cannot be reached right now.'}
      </p>
      <p className="offlineScreenHint">Downread keeps trying and continues automatically as soon as the connection is back.</p>
      <TextButton label={retrying ? 'Trying…' : 'Try again'} type="major" busy={retrying} onClick={retry} />
    </div>
  );
};

export default OfflineScreen;
